import { useAuth } from "$/util/auth";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import CreditProgress from "./CreditProgress";
import PricingSection from "./PricingSection";

function PricingModal(props) {
  const auth = useAuth();
  const { modalClosedCallback, forceOpen } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timer: string | number | NodeJS.Timeout;
    // when forceOpen=true open the moda without any delay
    if (forceOpen) {
      setOpen(true);
    } else {
      // Delay opening the dialog so user can see the design for a moment
      timer = setTimeout(() => {
        setOpen(true);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [auth.user, forceOpen]);

  // To pass modal closed info to called component
  useEffect(() => {
    if (!open && forceOpen) {
      const timer = setTimeout(() => {
        modalClosedCallback();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      maxWidth="lg"
      fullWidth
      fullScreen={fullScreen}
    >
      <IconButton
        aria-label="close"
        onClick={() => {
          setOpen(false);
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          zIndex: 100,
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          p: 0,
          pb: 2,
        }}
      >
        <DialogTitle>
          <Stack
            direction={{
              xs: "column",
              md: "row",
            }}
            spacing={2}
            mr={3}
          >
            <Box>
              {auth.user && auth.user.stripeSubscriptionId
                ? "Your plan has expired. Resubscribe to continue creating designs."
                : "Create unlimited tattoo designs. Get closer to your vision for your next tattoo."}
            </Box>
            <CreditProgress credits={auth.user ? auth.user.credits : 0} hideButton />
          </Stack>
        </DialogTitle>

        <PricingSection size="xsmall" />
      </DialogContent>
    </Dialog>
  );
}

export default PricingModal;
